module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('Background', {
    ref: "background"
  }), " ", _h('span', {
    staticClass: "site-title"
  }, ["ROBOT D"]), " ", _h('nav', {
    staticClass: "nav"
  }, [_h('ul', {
    staticClass: "nav-list"
  }, [_h('li', {
    staticClass: "nav-li"
  }, [_h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleNavClick($event)
      }
    }
  }, ["About"])]), " ", _h('li', {
    staticClass: "nav-li"
  }, [_h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/cv"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleNavClick($event)
      }
    }
  }, ["CV"])]), " ", _h('li', {
    staticClass: "nav-li"
  }, [_h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/work"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleNavClick($event)
      }
    }
  }, ["Work"])])])]), " ", _h('div', {
    staticClass: "content"
  }, [_h('router-view')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d7ea524!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 23
// module chunks = 1